import React, { useState } from 'react';

import copy from 'fast-copy';
import { jsPDF } from 'jspdf';

import html2canvas from 'html2canvas';
import { useTranslation } from 'react-i18next';

import { getDeploymentDateTime, getPreciseTime, getTimeAsZDateTime } from '../../../Functions/utils';
import { useAppContext } from '../../../Context/App/Provider';

import { toast } from 'react-toastify';
import BeatLoader from 'react-spinners/BeatLoader';
import { colors } from '../../../Shared/utils';

import { saveAs } from "file-saver";

import { devicesTypeValues } from '../../../Shared/utils';


import {
  getWidgetDataForImageDeployment, getWidgetDataForDeviceErasure,
  getWidgetDataForDiskErasurePerCapacity, getWidgetDataForDiskErasurePerProtocol,
  getWidgetDataForDiskErasurePerBrand, getWidgetDataForDiskErasurePerBrandAndModel,
  getWidgetDataForDiagnostics, getWidgetDataForDiagnosticsPerTest,
  getWidgetDataForDisksErasurePerCapacity, getWidgetDataForDisksErasurePerProtocol,
  getWidgetDataForDisksErasurePerBrand, getWidgetDataForDisksErasurePerBrandAndModel,
  getWidgetDataForImageCapture, getWidgetDataForImageCapturePerOS
} from './WidgetsData';


import Swal from 'sweetalert2'


function addTestLines(doc, marginTop, marginLeft, marginRight) {
  const testH = 200;

  const pageWidth = doc.internal.pageSize.width;  //Optional
  const pageHeight = doc.internal.pageSize.height;  //Optional

  doc.setLineWidth(0.1);
  doc.setDrawColor(255, 0, 0);

  doc.line(marginLeft, marginTop, pageWidth - marginRight, marginTop);
  doc.line(marginLeft, marginTop, marginLeft, pageHeight - marginTop);

  doc.line(marginLeft, pageHeight - marginTop, pageWidth - marginRight, pageHeight - marginTop);
  doc.line(pageWidth - marginRight, marginTop, pageWidth - marginRight, pageHeight - marginTop);

  // doc.line(0, testH, 0, testH + 30); // vertical line
  // doc.line(10, testH, 10, testH + 10); // vertical line
  // doc.line(20, testH, 20, testH + 10); // vertical line
  // doc.line(30, testH, 30, testH + 10); // vertical line
  // doc.line(40, testH, 40, testH + 10); // vertical line
  // doc.line(50, testH, 50, testH + 15); // vertical line
  // doc.line(60, testH, 60, testH + 10); // vertical line
  // doc.line(70, testH, 70, testH + 10); // vertical line
  // doc.line(80, testH, 80, testH + 10); // vertical line
  // doc.line(90, testH, 90, testH + 10); // vertical line

  // doc.line(100, testH, 100, testH + 30); // vertical line
  // doc.line(110, testH, 110, testH + 10); // vertical line
  // doc.line(120, testH, 120, testH + 10); // vertical line
  // doc.line(130, testH, 130, testH + 10); // vertical line
  // doc.line(140, testH, 140, testH + 10); // vertical line
  // doc.line(150, testH, 150, testH + 15); // vertical line
  // doc.line(160, testH, 160, testH + 10); // vertical line
  // doc.line(170, testH, 170, testH + 10); // vertical line
  // doc.line(180, testH, 180, testH + 10); // vertical line
  // doc.line(190, testH, 190, testH + 10); // vertical line

  // doc.line(200, testH, 200, testH + 30); // vertical line
  // doc.line(210, testH, 210, testH + 10); // vertical line
  // doc.line(220, testH, 220, testH + 10); // vertical line
  // doc.line(230, testH, 230, testH + 10); // vertical line
  // doc.line(240, testH, 240, testH + 10); // vertical line
  // doc.line(250, testH, 250, testH + 15); // vertical line
  // doc.line(260, testH, 260, testH + 10); // vertical line
  // doc.line(270, testH, 270, testH + 10); // vertical line
  // doc.line(280, testH, 280, testH + 10); // vertical line
  // doc.line(290, testH, 290, testH + 10); // vertical line

  // doc.line(300, testH, 300, testH + 30); // vertical line
  // doc.line(310, testH, 310, testH + 10); // vertical line
  // doc.line(320, testH, 320, testH + 10); // vertical line
  // doc.line(330, testH, 330, testH + 10); // vertical line
  // doc.line(340, testH, 340, testH + 10); // vertical line
  // doc.line(350, testH, 350, testH + 15); // vertical line
  // doc.line(360, testH, 360, testH + 10); // vertical line
  // doc.line(370, testH, 370, testH + 10); // vertical line
  // doc.line(380, testH, 380, testH + 10); // vertical line
  // doc.line(390, testH, 390, testH + 10); // vertical line

  // doc.line(400, testH, 400, testH + 30); // vertical line
  // doc.line(410, testH, 410, testH + 10); // vertical line
  // doc.line(420, testH, 420, testH + 10); // vertical line
  // doc.line(430, testH, 430, testH + 10); // vertical line
  // doc.line(440, testH, 440, testH + 10); // vertical line
  // doc.line(450, testH, 450, testH + 15); // vertical line
  // doc.line(460, testH, 460, testH + 10); // vertical line
  // doc.line(470, testH, 470, testH + 10); // vertical line
  // doc.line(480, testH, 480, testH + 10); // vertical line
  // doc.line(490, testH, 490, testH + 10); // vertical line
}


function addTable(doc, docWidth, docHeight, w, marginTop, marginRight, h, title, headers, widgetRows, pageColumns = 1, currentColumn = 1, topWidgetNextH = 0, pageno = 1) {

  // console.log("------------- ", title);
  // console.log("108 - headers= ", headers);
  // console.log("108 - currentColumn= ", currentColumn);
  // console.log("108 - topWidgetNextH= ", topWidgetNextH);
  // console.log("108 - w= ", w);
  // console.log("114 - widgetRows= ", widgetRows);

  docWidth = docWidth / pageColumns;
  w = w + (docWidth * (currentColumn - 1));

  const optionsL = {
    isInputVisual: false,
    isOutputVisual: true,
    isInputRtl: false,
    isOutputRtl: false,
    align: "right"
  };

  const optionsR = {
    isInputVisual: false,
    isOutputVisual: true,
    isInputRtl: false,
    isOutputRtl: false,
    align: "left"
  };

  let tabledrawy = h;
  let shiftCurrentRows = 0;

  const padding = 13;
  const reducetablewidth = docWidth - 3;
  const xPositions = [];

  let tablerowheight = 10;
  let tablecellpadding = 5;

  const fontSizeTitle = 10;  // 10
  const fontSizeTable = 7;  // 7


  //headers
  let headerxpos = w + 5; //default start
  let headerLinesCount = 1;
  let totalWidth = 0;
  headers.forEach((heading, index) => {
    totalWidth = totalWidth + heading.width;

    const headerNameSplitted = heading.headerName.split(' \u2013 ');
    const count = headerNameSplitted.length;
    if (count > headerLinesCount)
      headerLinesCount = count;
  });

  // 2nd passe
  let bonusHeaderLinesCount = 0;
  doc.setFont("customFont", "bold");
  doc.setFontSize(fontSizeTable);
  headers.forEach((heading, index) => {
    const headerNameSplitted = heading.headerName.split(' \u2013 ');

    let bonus = 0;
    for (const line of headerNameSplitted) {
      const longText = doc.splitTextToSize(
        line,
        reducetablewidth * heading.width / totalWidth * .95
      );
      bonus = bonus + longText.length - 1;
    }
    const count = headerNameSplitted.length + bonus
    if (count > headerLinesCount)
      headerLinesCount = count;
  });
  // console.log("182 - headerLinesCount=", headerLinesCount)
  // console.log("183 - bonusHeaderLinesCount=", bonusHeaderLinesCount)
  // headerLinesCount = headerLinesCount + bonusHeaderLinesCount;


  //let bottompagemargin = 20;
  if (tabledrawy + 3 * padding + (headerLinesCount * (tablerowheight-2)+3) > docHeight + marginTop) {

    // console.log("166 - currentColumn=", currentColumn);
    // console.log("167 - pageColumns=", pageColumns);

    if (currentColumn < pageColumns) {
      currentColumn++;

      if (pageno === 1)
        tabledrawy = topWidgetNextH;
      else
        tabledrawy = marginTop + tablerowheight;

      shiftCurrentRows = 0;
      w = w + (docWidth * (currentColumn - 1));
      headerxpos = w + 5; //default start
    }
    else {
    doc.addPage();
      w = w - (docWidth * (currentColumn - 1));
      headerxpos = w + 5; //default start

      currentColumn = 1;
      shiftCurrentRows = 0;
    tabledrawy = marginTop + tablerowheight;
    pageno = pageno + 1;

      // if (pageColumns > 1)
      //   shiftCurrentRows = -1;
  }
  }


  //title
  doc.setFont("customFont", "bold");
  doc.setTextColor("#000000");
  doc.setFontSize(fontSizeTitle);
  doc.text(title, w, tabledrawy, optionsR);

  //Purple line
  // doc.setLineHeightFactor(5);
  doc.setLineWidth(1);
  // doc.setDrawColor(0, 0, 0);
  doc.setDrawColor(169, 28, 132);
  doc.line(w, tabledrawy + 5, docWidth + w - 3, tabledrawy + 5);

  // console.log("151 - headerLinesCount=", headerLinesCount);

  doc.setFillColor('#efefef');
  doc.rect(
    w,
    tabledrawy + 5,
    docWidth - 3,
    headerLinesCount * (tablerowheight - 2) + 3,
    "F"
  );

  tabledrawy = tabledrawy + padding;
  headers.forEach((heading, index) => {
    const xsize = (reducetablewidth * heading.width / totalWidth) - (index === headers.length - 1 ? marginRight : tablecellpadding);
    const yPositionForHeaders = tabledrawy;

    doc.setTextColor("#000000");
    doc.setFontSize(fontSizeTable);

    const headerNameSplitted = heading.headerName.split(' \u2013 ');
    // console.log("headerNameSplitted=", headerNameSplitted);
    // console.log("267 - headerNameSplitted=", heading, index, index === 0 ? headerxpos : headerxpos + padding, xsize, headerNameSplitted, doc.getTextDimensions(headerNameSplitted));

    if (heading.align === "right") {
      const xpos = (index === 0 ? headerxpos : headerxpos + padding) + xsize - doc.getTextDimensions(headerNameSplitted).w - 2.5;
      doc.text(
        headerNameSplitted,
        xpos,
        yPositionForHeaders,
        { maxWidth: (reducetablewidth * heading.width / totalWidth) * .95 }
      );

    } else if (heading.align === "center") {
      const xpos = (index === 0 ? headerxpos : headerxpos + padding) + (xsize - doc.getTextDimensions(headerNameSplitted).w - 2.5)/2;
      doc.text(
        headerNameSplitted,
        xpos,
        yPositionForHeaders,
        { maxWidth: (reducetablewidth * heading.width / totalWidth) * .95 }
      );
    } else {
    doc.text(
      headerNameSplitted,
      index === 0 ? headerxpos : headerxpos + padding,
        yPositionForHeaders,
        { maxWidth: (reducetablewidth * heading.width / totalWidth) * .95 }
    );
    }

    xPositions.push(index === 0 ? headerxpos : headerxpos + padding);

    const xPositionForCurrentHeader = headerxpos + (reducetablewidth * heading.width / totalWidth)
    headerxpos =
      index + 1 === headers.length ? w + 5 : xPositionForCurrentHeader;
  });


  // ROWS
  tabledrawy = tabledrawy + (headerLinesCount * (tablerowheight-2))+3;

  widgetRows.forEach((row, rowIndex) => {
    const rowHeights = [];
    const rowRectHeights = [];

    // console.log("296 - --- --- ---");

    let newrowcells = [];
    headers.forEach((column, colIndex) => {
      const xPositionForCurrentHeader = (reducetablewidth * column.width / totalWidth) - (colIndex === headers.length - 1 ? marginRight : tablecellpadding);

      let data = String(row[column.field]).replaceAll(/ /g, " ");
      if (row["interpreted_$$_" + column.field]) {
        data = String(row["interpreted_$$_" + column.field]).replaceAll(/ /g, " ");

        // console.log("305 - 1=", row["interpreted_$$_" + column.field]);
        // console.log("306 - 2=", String(row["interpreted_$$_" + column.field]));
        // console.log("307 - data=", data);
      }

      const longText = doc.splitTextToSize(
        row[column.field] ? data : "-",
        xPositionForCurrentHeader
      );

      const rowHeight = (longText.length * (tablerowheight-2))+3;
      rowHeights.push(rowHeight);

      const rowRectHeight = longText.length > 1 ? (longText.length * (tablerowheight-2))+3 : tablerowheight;
      rowRectHeights.push(rowRectHeight);

      let cellobj = {
        text: longText,
        xpos: xPositions[colIndex] + shiftCurrentRows * docWidth,
        xsize: xPositionForCurrentHeader,
        ypos: tabledrawy,
        align: column.align
      };
      newrowcells.push(cellobj);
    });
    // console.log("313 - newrowcells=", newrowcells);
    // console.log("313 - rowHeights=", rowHeights);
    // console.log("313 - rowRectHeights=", rowRectHeights);

    let nextaddy = Math.max(...rowHeights) > tablerowheight ? Math.max(...rowHeights) : tablerowheight;

    doc.setFont("customFont", "normal");

    if (rowIndex % 2 === 1) {
      // doc.setTextColor("#950870");
      doc.setTextColor(121, 0, 84);
    }
    else
    doc.setTextColor("#000000");
    doc.setFontSize(fontSizeTable);

    newrowcells.forEach((rowcell, cellIndex) => {
      // console.log("267 - rowcell=", rowIndex, cellIndex, rowcell, doc.getTextDimensions(rowcell.text));

      if (rowcell.align === "right") {
        const xpos = rowcell.xpos + rowcell.xsize - doc.getTextDimensions(rowcell.text).w - 2.5;
        doc.text(rowcell.text, xpos, rowcell.ypos);

      } 
      else if (rowcell.align === "center") {
        const xpos = rowcell.xpos + (rowcell.xsize - doc.getTextDimensions(rowcell.text).w - 2.5)/2;
        doc.text(rowcell.text, xpos, rowcell.ypos);

      } 
      else {
      doc.text(rowcell.text, rowcell.xpos, rowcell.ypos);
    }
    });
    tabledrawy = tabledrawy + nextaddy;

    //let bottompagemargin = 20;
    if (tabledrawy + nextaddy > docHeight + marginTop) {
      if (currentColumn < pageColumns) {
        shiftCurrentRows = shiftCurrentRows + 1; //currentColumn;

        currentColumn++;
        if (pageno === 1)
          tabledrawy = topWidgetNextH;
        else
          tabledrawy = marginTop + tablerowheight;

        w = w + (docWidth * (currentColumn - 1));
      }
      else {
        if (pageColumns > 1)
          shiftCurrentRows = shiftCurrentRows - 1;//* currentColumn;

        currentColumn = 1;
      doc.addPage();
      tabledrawy = marginTop + tablerowheight;
      pageno = pageno + 1;
    }
    }
  });

  const retValue = {
    nextH: tabledrawy,
    colN: currentColumn,
    curPage: pageno
  };
  // console.log("321 - retValue=", retValue, title);
  return retValue;
}



export default function ExportDeployments(
  {
    disabled, apiRef, loading, model, setModel, selectionModel, reportingColumns, getInterpretedData, label, labelLight,
     deployments, rows, settings, scenario, sidebar, scenarioType = devicesTypeValues.PCs, uniqueCount
  }) {

  // console.log("28 - selectionModel=", selectionModel);
  // console.log("29 - deployments=", deployments);
  // console.log("404 - rows=", rows);
  // console.log("31 - reportingColumns=", reportingColumns);

  const localRows = copy(rows);

  const { t } = useTranslation();

  const [{ storedEnabledWidgets }, appDispatch] = useAppContext();

  // const [{ settings }] = useAppContext();

  const lang = settings.lang;
  const period = settings.period;
  const orientation = settings.orientation || "portrait";


  const pdfDownload = () => {

    // const values = Array.from(apiRef.current.getVisibleRowModels().values()).filter(line => selectionModel.includes(line.id));
    const values = selectionModel.length === 0 ? Array.from(apiRef.current.getVisibleRowModels().values()) : Array.from(apiRef.current.getVisibleRowModels().values()).filter(line => selectionModel.includes(line.id));
    // console.log("23 - values=", values);

    let groupName = '~noname~';
    let groupCount = 0;
    for (const value of values) {
      if (groupName !== value.general_$$_group) {
        groupName = value.general_$$_group;
        groupCount++;
      }

      if (groupCount > 1)
        break;
    }

    let prefix = '';
    if (groupCount === 1)
      prefix = '(' + groupName + ')_';

    const date = getDeploymentDateTime();
    const fileDate = date.year + date.month + date.day + '-' + date.time.split(':').join('');
    const defaultFileName = prefix + t('reporting.export.filename', { date: fileDate }) + "_" + labelLight;

    Swal.fire({
      allowOutsideClick: false,
      title: t('global.dialog_title'),
      html: t('reporting.export.enter_filename'),
      input: "text",
      inputValue: defaultFileName,
      showCancelButton: true,
      confirmButtonText: t("global.ok"),
      cancelButtonText: t("global.cancel"),
      customClass: {
        confirmButton: 'confirm-button-class',
        title: 'title-class',
        icon: 'icon-class'
      }
    }).then((value) => {
      // console.log("99 - value=", value);

      if (value && value.isConfirmed) {
        let inputFileName = (value && value.value !== "" ? value.value : defaultFileName)

        Swal.fire({
          allowOutsideClick: false,
          title: t('global.dialog_title'),
          html: t('reporting.export.pdf_in_progress'),
          showCancelButton: false,
          showConfirmButton: false,
          customClass: {
            confirmButton: 'confirm-button-class',
            title: 'title-class',
            icon: 'icon-class'
          }
        });
        processPDFDownload(inputFileName); //, scenarioType);
      };
    });
  }



  const processPDFDownload = async (inputFileName, scenarioType) => {
    setTimeout(() => {

      Swal.update({
        html: t('reporting.export.pdf_in_progress') + t('reporting.export.gathering_data') + "...",
      });

      //const values = Array.from(apiRef.current.getVisibleRowModels().values()).filter(line => selectionModel.includes(line.id));
      const values = selectionModel.length === 0 ? Array.from(apiRef.current.getVisibleRowModels().values()) : Array.from(apiRef.current.getVisibleRowModels().values()).filter(line => selectionModel.includes(line.id));
      // console.log("370 - values=", values);

      // console.log("101 - values=", values);
      // console.log("102 - reportingColumns=", reportingColumns);

      for (const line of Array.from(values)) {
        for (const column of reportingColumns) {

          const params = {
            formattedValue: line[column.field],
            field: column.field
          }
          line["interpreted_$$_" + column.field] = getInterpretedData ? getInterpretedData(params) : "";
          // line[column.field] = getInterpretedData(params);
        }
      }
      // console.log("116 - values=", values);


      // let serialText = '';
      // let serialKey = -1;
      // reportingColumns.every((col, key) => {
      //   if (scenarioType === devicesTypeValues.PCs) {
      //     if (col.field === 'system_$$_serial_number') {
      //       serialText = col.headerName;
      //       serialKey = key;
      //       return false;
      //     }
      //     return true;
      //   }
      //   else if (scenarioType === devicesTypeValues.disks) {
      //     if (col.field === 'disks_wipe_$$_serial') {
      //       serialText = col.headerName;
      //       serialKey = key;
      //       return false;
      //     }
      //     return true;
      //   }
      //   return true;
      // });


      // const tmp = [];
      // if (serialKey !== -1) {
      //   for (const val of values) {

      //     let serialQuery = "";
      //     if (scenarioType === devicesTypeValues.PCs) {
      //       serialQuery = "system_$$_serial_number";
      //     }
      //     else if (scenarioType === devicesTypeValues.disks) {
      //       serialQuery = "disks_wipe_$$_serial";
          // }

      //     const found = tmp.find(v => {
      //       if (v[serialQuery] === val[serialQuery]) {
      //         if (
      //           v["system_$$_uuid"] === val["system_$$_uuid"] &&
      //           v["motherboard_$$_model"] === val["motherboard_$$_model"] &&
      //           v["cpu_$$_model"] === val["cpu_$$_model"]
      //         ) {
      //           return true;
      //         }
      //       }
      //       return false;
          // });

          // if (!found) {
      //       tmp.push(val);
      //     }
      //   }
          // }

      const dateOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit'
      };
      const currentDate = new Date().toLocaleDateString(lang ? lang : 'en', dateOptions);

      const start = getPreciseTime(period, 'start');
      const end = getPreciseTime(period, 'end');
      const startDate = new Date(new Date(+start).getTime() + Math.abs(new Date(+start).getTimezoneOffset() * 60000)).toJSON().slice(0, 10);
      const endDate = new Date(new Date(+end).getTime() + Math.abs(new Date(+end).getTimezoneOffset() * 60000)).toJSON().slice(0, 10);

      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      };

      // PDF CONST 
      const fontSizeBanner = 20;
      const fontSizeTableDetails = 7;
      const fontSizeFooter = 6;

      let formatPDF = "A4"

      const doc = new jsPDF(
        // 'portrait',
        orientation,
        'pt',
        formatPDF
      );

      const info = jsPDF.getPageSize(
        // 'portrait',
        orientation,
        'pt',
        formatPDF
      );

      doc.addFont('assets/fonts/FreeSansBold.ttf', "customFont", "bold");
      doc.addFont('assets/fonts/FreeSerif.ttf', "customFont", "normal");

         
      // console.log("579 - getFontList=", doc.getFontList());

      const marginTop = 20;
      const marginLeft = 20;
      const marginRight = 20;
      const docLeft = Math.round(marginLeft);
      const docWidth = Math.round(info.width - (marginLeft + marginRight));
      const docHeight = Math.round(info.height - (2 * marginTop));
      const docHalfWidth = Math.round((docWidth / 2) - ((marginLeft + marginRight) / 4));
      const docMiddle = Math.round((docWidth / 2) + ((marginLeft + marginRight) / 4));

      // console.log("266 - docLeft=", docLeft);
      // console.log("267 - docHeight=", docHeight);
      // console.log("267 - docWidth=", docWidth);
      // console.log("268 - docHalfWidth=", docHalfWidth);
      // console.log("269 - docMiddle=", docMiddle);

      const maxY = info.height - (marginLeft + marginRight);
      let arrayText = [];

      let softthinksLogo = new Image()
      softthinksLogo.src = 'assets/images/softthinks.png'
      doc.addImage(softthinksLogo, 'png', marginLeft, marginTop, 66, 28);

      // BANNER
      doc.setDrawColor(0, 0, 0, 0.2);
      doc.setFillColor(0, 0, 0, 0.2);
      // doc.rect(marginLeft + 76, marginTop, docWidth - 76, 28, "F");

      doc.setFont("customFont", "bold");
      doc.setFontSize(fontSizeBanner);
      doc.setTextColor(169, 28, 132);
      doc.text(" " + t('global.dialog_title'), marginLeft + 76 + 10, marginTop + 22);


      // DEFAULT 
      doc.setFont("customFont", "normal");
      doc.setFontSize(fontSizeTableDetails);
      doc.setTextColor(0, 0, 0);

      let currentW = marginLeft;
      let currentH = marginTop + 50;
      let nextW = currentW + 10;
      let nextH = currentH + 10;
      let maxNextH = nextH;

      let colN = 1;
      let curPage = 1;

      // TABLE DETAILS     
      arrayText = [
        t('reporting.print.date') + " - "  + currentDate,
        t('reporting.print.from') + " " + new Date(getTimeAsZDateTime(startDate)).toLocaleDateString(lang ? lang : 'en', options) + " " + t('reporting.print.to') + " " + new Date(getTimeAsZDateTime(endDate)).toLocaleDateString(lang ? lang : 'en', options),
        label,
        (scenarioType === devicesTypeValues.disks ? t('reporting.print.disks') : t('reporting.print.devices')) + ": " + (values.length)
      ];
      if (uniqueCount > 0) {
        arrayText.push(
          (scenarioType === devicesTypeValues.disks ? t('reporting.different_disks') : t('reporting.print.different_devices')) + ": " + uniqueCount);
      }

      doc.text(arrayText, currentW, currentH);
      let textDimensions = doc.getTextDimensions(arrayText);

      nextW = currentW + textDimensions.w + 20;
      nextH = currentH + textDimensions.h + 20;

      // TABLES WIDGETS 
      // console.log("294 - storedEnabledWidgets=", storedEnabledWidgets);
      const topWidgetNextH = nextH;
      for (const widget of storedEnabledWidgets) {

        let widgetRows = [];
        const headers = [
          {
            id: 0,
            field: 'firstColumn',
            headerName: " ",
            width: 200,
            align: "left"
          },
          {
            id: 1,
            field: 'passed',
            headerName: t('reporting.columns.statistics.passed'),
            width: 47,
            align: 'right'
          },
          {
            id: 2,
            field: 'failed',
            headerName: t('reporting.columns.statistics.failed'),
            width: 47,
            align: 'right'
          },
          {
            id: 3,
            field: 'other',
            headerName: t('reporting.columns.statistics.other'),
            width: 47,
            align: 'right'
          },
          {
            id: 4,
            field: 'total',
            headerName: t('reporting.columns.statistics.total'),
            width: 59,
            align: 'right'
          }
        ];

        if (widget === "diagnostics") {
          widgetRows = getWidgetDataForDiagnostics({ rows: values, deployments, t, scenario });
        }
        else if (widget === "diagnostics_per_test") {
          widgetRows = getWidgetDataForDiagnosticsPerTest({ rows: values, deployments, t, scenario });
        }
        else if (widget === "image_deployment") {
          widgetRows = getWidgetDataForImageDeployment({ rows: values, deployments, t, scenario });
        }
        else if (widget === "image_capture") {
          widgetRows = getWidgetDataForImageCapture({ rows: values, deployments, t, scenario });
        }
        else if (widget === "image_capture_per_os") {
          widgetRows = getWidgetDataForImageCapturePerOS({ rows: values, deployments, t, scenario });
        }
        else if (widget === "device_erasure") {
          widgetRows = getWidgetDataForDeviceErasure({ rows: values, deployments, t, scenario });
        }
        else if (widget === "disk_erasure_per_capacity") {
          headers[0].headerName = t('reporting.columns.statistics.disk_capacity');
          widgetRows = getWidgetDataForDiskErasurePerCapacity({ rows: values, deployments, t, scenario });
        }
        else if (widget === "disk_erasure_per_protocol") {
          headers[0].headerName = t('reporting.columns.statistics.erasure_protocol');
          widgetRows = getWidgetDataForDiskErasurePerProtocol({ rows: values, deployments, t, scenario });
        }
        else if (widget === "disk_erasure_per_brand") {
          headers[0].headerName = t('reporting.columns.statistics.disk_brand');
          widgetRows = getWidgetDataForDiskErasurePerBrand({ rows: values, deployments, t, scenario });
        }
        else if (widget === "disk_erasure_per_brand_and_model") {
          headers[0].headerName = t('reporting.columns.statistics.disk_brand_and_model');
          widgetRows = getWidgetDataForDiskErasurePerBrandAndModel({ rows: values, deployments, t, scenario });
        }



        else if (widget === "disks_erasure_per_capacity") {
          headers[0].headerName = t('reporting.columns.statistics.disk_capacity');
          widgetRows = getWidgetDataForDisksErasurePerCapacity({ rows: values, deployments, t, scenario });
        }
        else if (widget === "disks_erasure_per_protocol") {
          headers[0].headerName = t('reporting.columns.statistics.erasure_protocol');
          widgetRows = getWidgetDataForDisksErasurePerProtocol({ rows: values, deployments, t, scenario });
        }
        else if (widget === "disks_erasure_per_brand") {
          headers[0].headerName = t('reporting.columns.statistics.disk_brand');
          widgetRows = getWidgetDataForDisksErasurePerBrand({ rows: values, deployments, t, scenario });
        }
        else if (widget === "disks_erasure_per_brand_and_model") {
          headers[0].headerName = t('reporting.columns.statistics.disk_brand_and_model');
          widgetRows = getWidgetDataForDisksErasurePerBrandAndModel({ rows: values, deployments, t, scenario });
        }

        // [nextH, colN] 
        const retTmp = addTable(doc, docWidth, docHeight, marginLeft, marginTop, marginRight, nextH, t('reporting.columns.statistics.' + widget), headers, widgetRows, 2, colN, topWidgetNextH, curPage)// + 20;
        nextH = retTmp.nextH + 20;
        colN = retTmp.colN;
        curPage = retTmp.curPage;

        // console.log("723 - retTmp=", retTmp);


        if (maxNextH < nextH)
          maxNextH = nextH
      }
      //nextH = maxNextH;

      if (colN > 1) {
        doc.addPage();
        nextH = marginTop + 10;
      }


      // DATA : 
      // console.log("573 - selectionModel=", selectionModel);
      // console.log("574 - reportingColumns=", reportingColumns);
      // console.log("575 - rows=", values);
      // console.log("576 - settings=", settings);
      // console.log("577 - scenario=", scenario);

      const headers = reportingColumns.filter(col => {
        if (col.field === "general_$$_group" || col.field === "general_$$_location")
          return false;
        return true;
      });
      const retTmp = addTable(doc, docWidth, docHeight, marginLeft, marginTop, marginRight, nextH, "", headers.slice(0, 12), values);
      nextH = retTmp.nextH + 20;
      colN = retTmp.colN;

      doc.setTextColor("#000000");
      doc.setFontSize(fontSizeFooter);
      if (nextH + 3 * 13 > docHeight + marginTop) {
        doc.addPage();
        nextH = marginTop;
      }

      //Solution developed by
      doc.addImage(softthinksLogo, 'png', marginLeft + 40, nextH + 6, 100, 39);
      doc.text('Solution developed by:', marginLeft + 90, nextH, { align: 'center' });

      // Part of hardware diagnostics provided by      
      let passmarkLogo = new Image()
      passmarkLogo.src = 'assets/images/passmark.png'
      doc.addImage(passmarkLogo, 'png', docMiddle - 175 / 2, nextH - 6, 175, 62);
      doc.text('Part of hardware diagnostics provided by:', docMiddle, nextH, { align: 'center' });

      // Secure wipe certified by      
      let adisaLogo = new Image()
      adisaLogo.src = 'assets/images/adisa.png'
      doc.addImage(adisaLogo, 'png', docWidth - 175, nextH - 6, 175, 62);
      doc.text('Secure wipe certified by:', docWidth - 175 / 2, nextH, { align: 'center' });


      const pages = doc.internal.getNumberOfPages();
      const pageWidth = doc.internal.pageSize.width;  //Optional
      const pageHeight = doc.internal.pageSize.height;  //Optional
      doc.setFontSize(fontSizeFooter);  //Optional

      for (let j = 1; j < pages + 1; j++) {
        const text = `${j} / ${pages}`;

        let textDimensions = doc.getTextDimensions(text);

        let horizontalPos = pageWidth - marginRight - textDimensions.w  //Can be fixed number
        let verticalPos = pageHeight - marginTop + 5;  //Can be fixed number
        doc.setPage(j);

        doc.setFont("customFont", "bold");
        doc.setTextColor(169, 28, 132);
        doc.text(text, horizontalPos, verticalPos, { align: 'right' });

        // addTestLines(doc, marginTop, marginLeft, marginRight);
      }

      doc.save(inputFileName + '.pdf');
      Swal.close();
      return;


      // const options = {
      //   delimiter: '`'
      // };

      // let interpretedCsv = "";
      // let newLine = "";

      // // console.log("27 - ...getInterpretedData=", getInterpretedData);
      // if (getInterpretedData) {

      //   for (const column of reportingColumns) {
      //     if (interpretedCsv)
      //       interpretedCsv = interpretedCsv + '`'

      //     interpretedCsv = interpretedCsv + column.headerName;
      //   }
      //   interpretedCsv = interpretedCsv + '\r\n';

      //   console.log("121 - interpretedCsv=", interpretedCsv);
      //   console.log("122 - reportingColumns=", reportingColumns);

      //   // for (const line of Array.from(apiRef.current.getEditRowsModel().values())) {
      //   for (const line of Array.from(values)) {
      //     newLine = "";

      //     // console.log("41 - ...line=", line);
      //     for (const column of reportingColumns) {
      //       const params = {
      //         formattedValue: line[column.field],
      //         field: column.field
      //       }
      //       // console.log("54 - params=", params);
      //       // const test = getInterpretedData(params);

      //       // console.log("57 - test=", test);
      //       if (newLine)
      //         newLine = newLine + '`'

      //       let newCell = "";
      //       for (const element of getInterpretedData(params)) {
      //         if (newCell)
      //           newCell = newCell + ' / '
      //         newCell = newCell + element;
      //       }
      //       newLine = newLine + newCell;
      //     }
      //     interpretedCsv = interpretedCsv + newLine + '\r\n';
      //   }
      // }
      // console.log("153 - interpretedCsv=", interpretedCsv);
      // // toast(t('004'), { type: 'success' })

      // const csv = (interpretedCsv !== "") ? interpretedCsv : apiRef.current.getDataAsCsv(options);

      // // console.log("93 - csv=", csv.length);

      // // const date = getDeploymentDateTime();
      // // const fileDate = date.year + date.month + date.day + '-' + date.time.split(':').join('');

      // const printedColumns = [];
      // for (let i = 0; i < reportingColumns.length; i++) {
      //   // const element = reportingColumns[i];
      //   // if (true || element.print === true) {
      //   printedColumns.push(i);
      //   // }
      // }
      // // console.log("85 - printedColumns=", printedColumns);

      // // xlsxDownloadToPdf({
      // //   csv: csv,
      // //   lang: settings.lang,
      // //   filename: inputFileName, //t('reporting.export.filename', { date: fileDate }),
      // //   dashboardText: t('global.dashboard'),
      // //   printedColumns: printedColumns,
      // //   period: settings.period,
      // //   t,
      // //   reportingColumns,
      // //   label
      // // });

    }, 100);
  }


  return (
    <>
      <button
        disabled={loading || disabled}
        onClick={() => {
          pdfDownload()
        }}
        className="button icon"
        title={t('global.actions.pdf')}
      >
        <span className="material-icons-round" style={{ fontSize: '28px' }}>picture_as_pdf</span>
      </button>
    </>
  );
}
